import React from 'react';
import PropTypes from 'prop-types';
import TranslationContainer from '../../../translation/translation_container';
import { LightboxView } from './view_sections/lightbox_view';
import { LightboxViewHeadline } from './view_sections/lightbox_view_headline';
import { LightboxViewContent } from './view_sections/lightbox_view_content';
import { LightboxViewAction } from './view_sections/view_actions/lightbox_view_action';
import { LightboxFilterSelect } from './filters/lightbox_filter_select';
import { FilterToTypes } from '../../../../constants/filter/filter_to_types';
import { FilterTypeDefaultValues } from '../../../../constants/filter/filter_type_default_values';
import { Filters } from '../../../../constants/filter/filters';
import { FilterSections } from '../../../../constants/filter/filter_sections';
import { FilterSectionLabelTranslationKeys } from '../../../../constants/filter/filter_section_label_translation_keys';
import { FilterLabelTranslationKeys } from '../../../../constants/filter/filter_label_translation_keys';
import getTranslatedText from '../../../../helper/get_translated_text';

function LightboxPrice(props) {
    const sectionHeadlineTranslationKey = FilterSectionLabelTranslationKeys[FilterSections.PRICE_VIEW];
    const minPriceTranslationKey = getTranslatedText(FilterLabelTranslationKeys[Filters.PRICE_MIN]);
    const maxPriceTranslationKey = getTranslatedText(FilterLabelTranslationKeys[Filters.PRICE_MAX]);
    const minPriceDefaultValue = FilterTypeDefaultValues[FilterToTypes[Filters.PRICE_MIN]];
    const maxPriceDefaultValue = FilterTypeDefaultValues[FilterToTypes[Filters.PRICE_MAX]];

    const min = parseInt(props.minPriceValue, 10);
    const max = parseInt(props.maxPriceValue, 10);
    const disabled = Boolean(min && max && min > max);

    return (
        <LightboxView
            viewName={FilterSections.PRICE_VIEW}
            opened={props.opened}
        >
            <TranslationContainer translationKey={sectionHeadlineTranslationKey} targetProperty="headline">
                <LightboxViewHeadline headline="will-be-replaced" />
            </TranslationContainer>

            <LightboxViewContent>
                <LightboxFilterSelect
                    name={Filters.PRICE_MIN}
                    value={props.minPriceValue.toString()}
                    options={props.minPriceOptions}
                    labelTranslationKey={minPriceTranslationKey}
                    provideAllTranslationKey={minPriceTranslationKey}
                    onChange={props.onChange}
                    provideAllOption={true}
                    highlight={props.maxPriceValue !== maxPriceDefaultValue && props.minPriceValue === minPriceDefaultValue}
                />

                <LightboxFilterSelect
                    name={Filters.PRICE_MAX}
                    value={props.maxPriceValue.toString()}
                    options={props.maxPriceOptions}
                    labelTranslationKey={maxPriceTranslationKey}
                    provideAllTranslationKey={maxPriceTranslationKey}
                    onChange={props.onChange}
                    provideAllOption={true}
                    highlight={props.maxPriceValue === maxPriceDefaultValue}
                />

                {disabled && <p className="text-center color-error">
                    {getTranslatedText('catalog-filters-price-min-max-price-difference-msg', {
                        minPrice: minPriceTranslationKey,
                        maxPrice: maxPriceTranslationKey,
                    })}
                </p>}
            </LightboxViewContent>

            <LightboxViewAction
                onCloseClick={props.resetSection}
                onSaveClick={props.saveSection}
                disabled={disabled}
            />
        </LightboxView>
    );
}

LightboxPrice.propTypes = {
    minPriceValue: PropTypes.string.isRequired,
    maxPriceValue: PropTypes.string.isRequired,
    minPriceOptions: PropTypes.array.isRequired,
    maxPriceOptions: PropTypes.array.isRequired,
    currencyIsoCode: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    resetSection: PropTypes.func.isRequired,
    saveSection: PropTypes.func.isRequired,
    opened: PropTypes.bool.isRequired,
};

export { LightboxPrice };
